// extracted by mini-css-extract-plugin
module.exports = {"activeTableButton":"_f5bc2d1","disabled":"_a2fd63c"};